import React from "react";
import { TextField, TextArea } from "../../../common/FormFields";
import ShortDescriptionEditor from "../../../common/RichTextEditor/ShortDescriptionEditor";

/**
 * SubstepForm Component
 * 
 * Reusable form fields for Substep creation/editing
 * 
 * @param {Object} props
 * @param {string} props.mode - "add" or "edit"
 * @param {string} props.versionId - Version ID (for edit mode)
 * @param {string} props.shortDescription - Short description value
 * @param {function} props.onShortDescriptionChange - Handler for short description change
 */
const SubstepForm = ({
  mode = "add",
  versionId = "",
  shortDescription = "",
  onShortDescriptionChange,
  onShortDescriptionDirtyChange,
}) => {
  return (
    <form className="">
      <div >
        <div className="full-width">
          <TextField
            label="Version ID (Read Only)"
            name="id"
            value={mode === "edit" ? versionId : ""}
            disabled={true}
            readOnly={true}
            width="30%"
            style={{
              color: mode === "edit" ? "#999999" : "inherit",
            }}
          />
        </div>
      </div>

      <div >
        <div className="full-width" style={{ marginLeft: "10px", marginRight: "10px" }}>
          <label
            style={{
              fontWeight: "bold",
              color: "#333",
              marginLeft: "10px",
              marginBottom: "8px",
              display: "block",
            }}
          >
            Short Description
          </label>
          <ShortDescriptionEditor
            value={shortDescription}
            onChange={onShortDescriptionChange}
            onDirtyChange={onShortDescriptionDirtyChange}
            placeholder="Enter Short Description"
            minHeight="100px"
          />
        </div>
      </div>
    </form>
  );
};

export default SubstepForm;
